<template>
  <div
    class="pa-4 rounded-lg upload-zone"
    :class="{ colorBorde: estaArrastrando }"
    @dragover.prevent="estaArrastrando = true"
    @dragleave.prevent="estaArrastrando = false"
    @drop.prevent="validarArchivoSoltado"
  >
    <div class="d-flex align-center justify-center">
      <v-img
        v-if="vistaPrevia"
        :src="vistaPrevia"
        max-height="60"
        max-width="130"
        class="mr-4"
        contain
      ></v-img>

      <v-card
        elevation="4"
        class="text-center pa-2 rounded-xxl upload-button"
        @click="seleccionarArchivo"
        role="button"
        tabindex="0"
        @keyup.enter="seleccionarArchivo"
        :aria-label="vistaPrevia ? 'Editar logo' : 'Agregar logo'"
      >
        <v-icon color="grey darken-1" size="24">cloud_upload</v-icon>
        <div class="text-caption grey--text text--darken-1">
          {{ vistaPrevia ? 'EDITAR' : 'AGREGAR' }}
          <br />LOGO
        </div>
        <v-file-input
          v-model="logoCompania"
          accept="image/png"
          hide-input
          class="d-none"
          ref="fileInput"
          @change="validarArchivoSeleccionado"
        ></v-file-input>
      </v-card>

      <div class="ml-4 grey--text text-center">
        <p class="mb-0">O arrastra y suelta aquí</p>
        <small>.PNG</small>
      </div>
    </div>
  </div>
</template>

<script>
import apiDocumentosService from '../Services/apiDocumentosService';

export default {
  name: 'ImagenCompania',

  props: {
    nombreLogo: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      logoCompania: null,
      vistaPrevia: '',
      estaArrastrando: false,
    };
  },

  watch: {
    logoCompania(nuevoArchivo) {
      if (nuevoArchivo === null) {
        return;
      }

      this.$emit('input', nuevoArchivo);
      this.$emit('change', nuevoArchivo);
    },
    nombreLogo: {
      immediate: true,
      async handler(nuevoValor) {
        if (!nuevoValor) {
          this.vistaPrevia = '';
          return;
        }

        if (/^(https?:\/\/|data:image)/i.test(nuevoValor)) {
          this.vistaPrevia = nuevoValor;
          return;
        }

        await this.cargarImagenPrevia(nuevoValor);
      },
    },
  },

  methods: {
    seleccionarArchivo() {
      this.$refs.fileInput.$el.querySelector('input').click();
    },

    validarArchivoSeleccionado(archivo) {
      if (!archivo) {
        this.vistaPrevia = '';
        return;
      }

      if (archivo.type !== 'image/png') {
        this.mostrarError(
          'Formato de imagen incorrecto. Solo se permiten archivos .PNG.'
        );
        return;
      }

      this.convertirImagenPrevia(archivo);
    },

    validarArchivoSoltado(evento) {
      this.estaArrastrando = false;

      if (!evento.dataTransfer.files.length) {
        return;
      }

      const archivo = evento.dataTransfer.files[0];

      if (archivo.type !== 'image/png') {
        this.mostrarError(
          'Formato de imagen incorrecto. Solo se permiten archivos .PNG.'
        );
        return;
      }

      this.logoCompania = archivo;
      this.convertirImagenPrevia(archivo);
      this.$emit('change', archivo);
    },

    mostrarError(mensaje) {
      this.$emit('mostrar-error', mensaje);
      this.logoCompania = null;
    },

    convertirImagenPrevia(archivo) {
      if (!archivo) return;

      const lectorArchivo = new FileReader();
      lectorArchivo.onload = e => {
        this.vistaPrevia = e.target.result;
      };
      lectorArchivo.onerror = () => {
        this.mostrarError('Error al leer el archivo. Intente nuevamente.');
      };
      lectorArchivo.readAsDataURL(archivo);
    },

    async cargarImagenPrevia(nombreArchivo) {
      try {
        this.vistaPrevia = await apiDocumentosService.obtenerArchivo(
          'Logo',
          nombreArchivo
        );
      } catch {
        this.mostrarError('No fue posible cargar la vista previa del logo.');
      }
    },
  },
};
</script>

<style scoped>
.upload-zone {
  border: 2px dashed #ccc;
  min-height: 120px;
  transition: all 0.3s ease;
  background-color: transparent;
  border-color: #ccc;
}

.colorBorde {
  border-color: #1976d2;
  background-color: #1976d20d;
}

.upload-button {
  transition: transform 0.2s ease;
}

.upload-button:hover {
  transform: scale(1.05);
}

.upload-button:active {
  transform: scale(0.98);
}
</style>
